"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _dimensions = require("./dimensions");
Object.keys(_dimensions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _dimensions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _dimensions[key];
    }
  });
});